module.exports = __webpack_public_path__ + "static/media/st_anthonys_logo-removebg-preview.15a51aa3.png";